import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Rx'
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AdminService } from '../services/admin.service';
import {MatTableDataSource} from '@angular/material';



@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})

export class UsersComponent implements OnInit {
  users:any = [];

  role_msg = '';


 
  constructor( private adm : AdminService) {
    this.getUserList();
    setTimeout(function(){
      $(function(){
        $('#example').DataTable();
      });
    },3000);
   
   }

  ngOnInit() {
    this.role_msg = localStorage.getItem('role_msg');
    localStorage.removeItem('role_msg');
    
    
  }
  getUserList()
  {
    var users = this.adm.getUser().subscribe( res => {
     // console.log(res.users);
      this.users = res.users;
     
  })
  }
  

 

}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts